export default {
    init() {
    // JavaScript to be fired on the single kitchen pages

        //Fullscreen Image Modal on Button Click
        let fullScreenImageBtn = document.querySelector('button.slider-for__image__full-screen');
        let videoPlayBtn = document.querySelector('.kitchen-info__slider button.media-btn');
        let fullScreenModalImage = document.querySelector('#fullScreenKitchen img');
        let fullScreenModalVideo = document.querySelector('#fullScreenKitchen video');
        let videoSrc = null;
        let embedSrc = null;

        function showVideoFile(video) {
            // If a video hide the img tag and display video tag
            $('#fullScreenKitchen img').css('display', 'none');
            $('#fullScreenKitchen video').css('display', 'block');
            if($('#fullScreenKitchen iframe')) {
                ($('#fullScreenKitchen iframe')).css('display', 'none');
            }

            //Get source of original video
            videoSrc = video;

            //Update source of modal video
            fullScreenModalVideo.setAttribute('src', videoSrc);
        }

        function showVideoEmbed() {
            // If a video hide the img tag and display video tag
            $('#fullScreenKitchen img').css('display', 'none');
            $('#fullScreenKitchen video').css('display', 'none');
            ($('#fullScreenKitchen iframe')).css('display', 'block');

            //Get embed source
            embedSrc = $('#kcar-iframe iframe');

            //Update modal source
            $('#fullScreenKitchen .modal-dialog .modal-content .modal-body').append(embedSrc);
        }

        if(fullScreenImageBtn){
            fullScreenImageBtn.addEventListener('click', () => {
                let currentActiveImage = document.querySelector('.kitchen-info__slider .slick-current > img');
                // let currentActiveVideo = document.querySelector('.kitchen-info__slider .slick-current > video > source');
                let currentActiveSlide = document.querySelector('.kitchen-info__slider .slick-current');
                //If Upload
                if(currentActiveSlide.dataset.type.includes('video')) {
                    showVideoFile(currentActiveImage.dataset.video) 
                }
                //If Embed
                else if(currentActiveSlide.dataset.type.includes('embed')) {
                    showVideoEmbed();
                }
                //If image
                else {
                    // If an image hide the video tag and display image tag
                    $('#fullScreenKitchen img').css('display', 'block');
                    $('#fullScreenKitchen video').css('display', 'none');
                    if($('#fullScreenKitchen iframe')) {
                        ($('#fullScreenKitchen iframe')).css('display', 'none');
                    }

                    //Get source of original image
                    let fullSizeSrc = currentActiveImage.dataset.fullSizeImage;

                    //Update source of modal image
                    fullScreenModalImage.src = fullSizeSrc;
                }
            });

            //Open the modal when play button overlaying video is clicked
            if(videoPlayBtn){
                videoPlayBtn.addEventListener('click', () => {
                    let currentActiveImage = document.querySelector('.kitchen-info__slider .slick-current > img');
                    let currentActiveSlide = document.querySelector('.kitchen-info__slider .slick-current');
                    if(currentActiveSlide.dataset.type.includes('video')) {
                        showVideoFile(currentActiveImage.dataset.video);
                    } else if (currentActiveSlide.dataset.type.includes('embed')){
                        showVideoEmbed();
                    }
                });
            }
            
        }

        //When the modal is closed then stop the video
        $('#fullScreenKitchen').on('hide.bs.modal', function() {
            setTimeout(function() {
                fullScreenModalVideo.pause();
            }, 500);
        });

        //Kitchen Main Carousel
        $('.kitchen-info__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.kitchen-info__slider-nav',
            autoplay: false,
        });

        // Kitchen Mini Carousel
        $('.kitchen-info__slider-nav').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.kitchen-info__slider',
            dots: false,
            autoplay: false,
            centerMode: false,
            focusOnSelect: true,
            infinite: true,
            swipeToSlide: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            // arrows: false,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            }],
        });

        //Add margin to account for absolute positioned carousel on mobile
        if($(window).width() <= 575) {
            var carouselHeight = $('.kitchen-info__slider__image').css('height');
            $('.kitchen-single-top').css('margin-bottom', carouselHeight);
        }




        // Click on '+ 24' and jump and open right accordion
        const bestSellersCollapsible = document.getElementById('kitchen_colours-best-seller');
        const ptoCollapsible = document.getElementById('kitchen_colours-paint-to-order');

        const kitchenJumpToColours = (targetColourSection, openBoth) => {
            targetColourSection.classList.add('show');
            const colourAccordionHeader = targetColourSection.previousElementSibling;
            const colourAccordionIcon = colourAccordionHeader.querySelector('.accordion__icon');
            colourAccordionIcon.classList.remove('fa-plus-large');
            colourAccordionIcon.classList.add('fa-minus');

            // if there are best sellers and paint to order, open PTO too
            if(openBoth){
                ptoCollapsible.classList.add('show');
                const ptoAccordionHeader = ptoCollapsible.previousElementSibling;
                const ptoAccordionIcon = ptoAccordionHeader.querySelector('.accordion__icon');
                ptoAccordionIcon.classList.remove('fa-plus-large');
                ptoAccordionIcon.classList.add('fa-minus');
            }

            // scroll to target element
            const headerOffset = 150;
            var elementPosition = targetColourSection.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }

        const jumpButton = document.getElementById('kitchenJumpSection');
        if(jumpButton){
            jumpButton.addEventListener('click', () => {
                let openBoth = false;
                // if has both best sellers and PTO then open both
                if(bestSellersCollapsible && ptoCollapsible){
                    openBoth = true;
                    kitchenJumpToColours(bestSellersCollapsible, openBoth);
                } else if(bestSellersCollapsible){
                    kitchenJumpToColours(bestSellersCollapsible, openBoth);
                } else if(ptoCollapsible){
                    kitchenJumpToColours(ptoCollapsible, openBoth);
                }
            })
        }
        
    },
    finalize() {
      // JavaScript to be fired on the single kitchen pages, after the init JS
    },
  };
  

    
